module.exports = __webpack_public_path__ + "static/media/23.915dc77d.wav";